export enum Routes {
  USERS = '/users',
  EDIT_USER = '/users/:authProviderId',
  CREATE_USER = '/users/create',
  ROLES = '/users/roles',
  CREATE_ROLE = '/users/roles/create',
  EDIT_ROLE = '/users/roles/:id',
  CLAIMS = '/claims',
  CLAIM_FORMS = '/claim-forms',
  CLAIMS_ADMIN = '/claims-admin',
  PLAYER_SEARCH = '/players',
  PLAYER_DETAILS = '/players/:lookupId',
  PLAYER_DETAILS_COUPONS = '/players/:lookupId/coupons',
  PLAYER_DETAILS_SCANS = '/players/:lookupId/scans',
  PLAYER_DETAILS_SPINS = '/players/:lookupId/spins',
  SEARCH_ANALYTICS = '/reports/search-analytics',
  CLAIMS_REPORTS = '/reports/claims-reports',
  COUPON_PROMOTIONS = '/coupons-admin',
  CREATE_COUPON_PROMOTIONS = '/coupons-admin/create',
  VIEW_COUPON_PROMOTION = '/coupons-admin/:couponPromotionId',
  SEARCH_CONFIGURATION = '/search/configuration',
  IMPORTS = '/imports',
  IMPORT_DETAILS = '/imports/:importId',
  PLUGINS = '/plugins',
  API_KEYS = '/api-keys',
  CREATE_API_KEY = '/api-keys/create',
  EDIT_API_KEY = '/api-keys/:keyId',
  PROMOTION_CAMPAIGNS = '/promotion-campaigns',
  TICKET_SCAN_SEARCH = '/ticket-scan-search',
  SCANNER_SCHEDULED_DOWNTIME = '/scanner-scheduled-downtime',
  CUSTOMER_CONFIG = '/customer-config',
}
